<template>
  <section>
    <!--工具条-->
    <HSAccessRecordToolbar :buttonList="buttonList" @callFunction="callFunction">
    </HSAccessRecordToolbar>

    <!--列表-->
    <el-table :data="hsAccessRecordList" highlight-current-row v-loading="listLoading"
      @current-change="selectCurrentRow" style="width: 100%;">
      <el-table-column fixed="left" type="index" label="序号" width="60"></el-table-column>
      <el-table-column fixed="left" prop="CustomName" label="客户名称" width="150"></el-table-column>
      <el-table-column prop="CustomerId" label="CustomerId" width="150" v-if="false"></el-table-column>
      <el-table-column prop="AccessTime" label="访问时间" width="180"></el-table-column>
      <el-table-column prop="Result" label="结果"></el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="Toolbar">
      <el-pagination layout="total, sizes, prev, pager, next" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" :current-page.sync="page" :page-sizes="[10, 15, 20, 50, 100, 200]"
        :total="total" style="float:right;"></el-pagination>
    </el-col>

  </section>
</template>

<script>
import util from "../../../util/date";
import { getHSAccessRecordListPage, deleteSendGpsVehicleByCustomerId } from "../../api/api";
import { getButtonList, getOperationButtonList } from "../../promissionRouter";
import HSAccessRecordToolbar from "../../components/QueryToolbar/HSAccessRecordToolbar";

export default {
  components: { HSAccessRecordToolbar },
  data() {
    return {
      filters: {
        customerId: "",
      },
      buttonList: [],
      operationButtonList: [],
      hsAccessRecordList: [],
      total: 0,
      page: 1,
      pageSize: 10,
      listLoading: false,
      sels: [], //列表选中列
      currentRow: null,
    };
  },
  methods: {
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters = {
        customerId: item.customerId,
      };
      this[item.Func].apply(this, item);
    },
    handleSizeChange(val) {
      this.page = 1;
      this.pageSize = val;
      this.getHSAccessRecord();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getHSAccessRecord();
    },
    queryHSAccessRecord() {
      this.page = 1;
      this.getHSAccessRecord();
    },
    getHSAccessRecord() {
      let _this = this;
      let para = {
        customerId: _this.filters.customerId,
        page: _this.page,
        pageSize: _this.pageSize
      };
      _this.listLoading = true;
      getHSAccessRecordListPage(para).then(res => {
        _this.total = res.data.response.dataCount;
        _this.hsAccessRecordList = res.data.response.data;
        _this.listLoading = false;
      });
    },
    handleDeleteSendGpsVehicleByCustomerId() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要删除客户所有发送gps的车的一行数据！",
          type: "error"
        });

        return;
      }
      this.$confirm("确认删除客户所有发送gps的车吗?", "提示", {
        type: "warning"
      })
        .then(() => {
          this.listLoading = true;
          let para = { customerId: row.CustomerId };
          deleteSendGpsVehicleByCustomerId(para).then(res => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            if (res.data.success) {
              this.$message({
                message: res.data.msg,
                type: "success"
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error"
              });
            }

            this.getHSAccessRecord();
          });
        })
        .catch(() => { });
    },
    selsChange: function (sels) {
      this.sels = sels;
    },
    //批量删除
    batchRemove: function () {
      this.$message({
        message: "该功能未开放",
        type: "warning"
      });
    },
    getButtonList2(routers) {
      let _this = this;
      routers.forEach(element => {
        let path = this.$route.path.toLowerCase();
        if (element.path && element.path.toLowerCase() == path) {
          _this.buttonList = element.children;
          return;
        } else if (element.children) {
          _this.getButtonList(element.children);
        }
      });
    }
  },
  mounted() {
    this.getHSAccessRecord();

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);

    //第二种写法，封装到 permissionRouter.js 中
    this.buttonList = getButtonList(this.$route.path, routers);
    this.operationButtonList = getOperationButtonList(this.$route.path, routers);
  }
}
</script>

<style scoped></style>
